import { render, staticRenderFns } from "./PromotionActionPointsGenerate.vue?vue&type=template&id=4a2c563e&"
import script from "./PromotionActionPointsGenerate.vue?vue&type=script&lang=js&"
export * from "./PromotionActionPointsGenerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemAvatar,VListItemContent})
